<template>
  <div v-editable="blok">
    <AppFaqs :title :faqs />
  </div>
</template>

<script lang="ts" setup>
  const { blok } = defineProps<{ blok: MarketingFaqsBlokStoryblok }>();
  const title = computed(() => renderRichText(blok.title) ?? '');
  const faqs = computed(() => {
    return resolveRelations(blok.faqs).map((faq) => {
      return {
        id: faq.uuid,
        question: faq.content['maintext-q-1'] ?? '',
        answer: (renderRichText(faq.content['maintext-a-1']) || '').replace(/&lt;br\/?&gt;/gi, '<br/>'),
      };
    });
  });
</script>
